import ListJob from "../components/listjob";

import Sidebar from "../components/sidebar";

function TableListJobPage() {
  return (
    <>
      <Sidebar>
        <ListJob />
      </Sidebar>
    </>
  );
}
export default TableListJobPage;
